import {
  FALLBACK_LANGUAGES,
  FALLBACK_LOCALE,
  FALLBACK_LOCALES,
  SUPPORTED_LOCALES,
} from '@/constants/content-stack'
import { ConfigStore } from '@/stores/config'
import { Locale } from '@/types/general'

const formatLocale = ({ language, country }: Locale) =>
  `${language}-${country}`.toLowerCase()

export function getLocale() {
  const { locale } = ConfigStore.getState()
  const formattedLocale = formatLocale(locale)

  if (SUPPORTED_LOCALES.includes(formattedLocale)) return formattedLocale

  return (
    FALLBACK_LOCALES[formattedLocale as keyof typeof FALLBACK_LOCALES] ||
    FALLBACK_LANGUAGES[
      locale.language.toLowerCase() as keyof typeof FALLBACK_LANGUAGES
    ] ||
    FALLBACK_LOCALE
  )
}
